var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartSickNoteCard_1;
import { Card, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import MyChartSickNoteCardAPI from './my-chart-sick-note-card-api';
import './my-chart-medical-data-card.css';
let MyChartSickNoteCard = class MyChartSickNoteCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick, nrSequence, professional, read, type, when } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        nrSequence,
                        professional,
                        read,
                        type,
                        when,
                    }
                }));
            }
        };
    }
    static { MyChartSickNoteCard_1 = this; }
    static { this.propTypes = {
        className: string,
        onClick: eventListener,
        uuid: string,
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    render() {
        const { professional, when, read, uuid, className, width = MyChartSickNoteCard_1.defaultProps.width } = this.props;
        const whenFormatted = ModelService.format('date', when, { type: 'shortDate' });
        const notViewedClass = read === 'N' ? 'not-viewed' : '';
        const medicalDataContentClass = `sick-note-card-content ${notViewedClass}`;
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.NONE, className: `my-chart-sick-note-card ${className || ''}`, width: width, onClick: () => this.onClick() },
            React.createElement("div", { className: medicalDataContentClass },
                React.createElement("div", { className: 'left-area' },
                    React.createElement("div", { className: 'icon-not-read' }),
                    React.createElement("div", { className: "avatar-area" },
                        React.createElement(Text, { value: `${MessageService.translate('patient.label.executor-profissional')}:` }),
                        React.createElement(Text, { value: professional, size: TextFontSize.SMALL, bold: true, className: "subtitle" }))),
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "date" },
                        React.createElement("span", null,
                            React.createElement(Text, { value: `${MessageService.translate('patient.date')}:` })),
                        React.createElement("span", null,
                            React.createElement(Text, { size: TextFontSize.SMALL, bold: true, value: whenFormatted, className: "subtitle" })))))));
    }
};
MyChartSickNoteCard = MyChartSickNoteCard_1 = __decorate([
    AwesomeComponent({ api: MyChartSickNoteCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartSickNoteCard);
export default MyChartSickNoteCard;
//# sourceMappingURL=my-chart-sick-note-card.js.map